export * from './routes'
export * from './config'


// WEBPACK FOOTER //
// ./src/config/index.ts